import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import LayeredStack from "@/components/LayeredStack";
import { Spinner } from "@/components/Kit";
import { playSfx } from "@/lib/sound";
import { BatteryCharging, Zap, Thermometer } from "lucide-react";

export default function ChargingDock() {
  const { pet, refreshPet } = useOutletContext();
  const [busy, setBusy] = useState(false);

  const recharge = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/station/recharge");
      await refreshPet(); playSfx("pop");
      toast.success(data.message);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="charging-dock-page">
      <span className="label-cap text-primary flex items-center gap-2"><BatteryCharging className="w-4 h-4" /> Doc Nanite // Medical Hologram</span>
      <h1 className="text-4xl font-black tracking-tighter mt-2 mb-6 font-head">Charging Dock</h1>
      <div className="panel-glow p-8 flex flex-col items-center hud-corner max-w-md">
        {pet && <LayeredStack layers={pet.layers} core={pet.core_color} rig={pet.rig} cpu={pet.cpu} size={180} state={pet.thermal >= 100 || pet.battery <= 0 ? "off" : "idle"} />}
        <div className="w-full mt-6 space-y-3">
          <div>
            <div className="flex justify-between label-cap mb-1"><span className="flex items-center gap-1"><Zap className="w-3 h-3" /> Battery</span><span>{pet?.battery}%</span></div>
            <div className="h-2 rounded bg-muted overflow-hidden"><div className="h-full" style={{ width: `${pet?.battery}%`, background: "hsl(var(--primary))" }} /></div>
          </div>
          <div>
            <div className="flex justify-between label-cap mb-1"><span className="flex items-center gap-1"><Thermometer className="w-3 h-3" /> Thermal Heat</span><span>{pet?.thermal}%</span></div>
            <div className="h-2 rounded bg-muted overflow-hidden"><div className="h-full" style={{ width: `${pet?.thermal}%`, background: "hsl(var(--secondary))" }} /></div>
          </div>
        </div>
        <button data-testid="recharge-btn" onClick={recharge} disabled={busy} className="btn-primary w-full mt-6">
          {busy ? <Spinner className="w-4 h-4" /> : "Rapid-Charge Pod (once/day)"}
        </button>
      </div>
    </div>
  );
}
